import { Box } from "@chakra-ui/react";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Spinner from "../../../shared/components/Spinner";
import ReadingOrderEndItem from "./ReadingOrderEndItem";
import ReadingOrderListItem from "./ReadingOrderListItem";

const ReadingOrderList = ({
  readingId,
  isLoading,
  isFetchingNextPage,
  upNext,
  upNextRef,
  readingOrderComics,
  fetchNextPage,
  hasNextPage,
  disableTracking,
}) => {
  // Auto scroll at the beginning
  React.useEffect(() => {
    if (!isLoading && !isFetchingNextPage && upNext) {
      if (upNextRef.current) {
        upNextRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [isLoading, isFetchingNextPage, upNext, upNextRef]);

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <div
        className="List"
        style={{
          width: `100%`,
          overflow: "auto",
        }}
      >
        <InfiniteScroll
          dataLength={readingOrderComics.length}
          next={fetchNextPage}
          hasMore={hasNextPage}
          loader={
            <Box px="3">
              <h4>Loading...</h4>
            </Box>
          }
          height="75vh"
          endMessage={
            <ReadingOrderEndItem>
              This concludes our reading order, 'nuff said!
            </ReadingOrderEndItem>
          }
        >
          {readingOrderComics.map((comic, i) => (
            <ReadingOrderListItem
              readingId={readingId}
              itemRef={
                comic.order ===
                (upNext && upNext?.order - 6 < 1
                  ? 1
                  : (upNext && upNext?.order) - 6)
                  ? upNextRef
                  : null
              }
              key={comic.order}
              comic={comic}
              isUpNext={upNext?.order === comic?.order}
              disableTracking={disableTracking}
            />
          ))}
        </InfiniteScroll>
      </div>
    </>
  );
};

export default ReadingOrderList;
